import * as svg from "../../../assets/file-edit-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const FileEditIcon = iconBuilder(svg, "FileEditIcon", "0 0 10 11");
